import { createEvent, restore, sample } from 'effector'
import { fx } from '../../../../libs'
import { BalanceSummaryData, PassiveBalancesData } from './types'

export const balanceSummaryMounted = createEvent()

export const getBalanceSummary = fx<void, BalanceSummaryData | null>({
  method: 'GET',
  url: '/finance/balance-summary-active',
})

export const getPassiveBalances = fx<void, PassiveBalancesData | null>({
  method: 'GET',
  url: '/finance/balance-summary-passive',
})

const defaultData: BalanceSummaryData = {
  openingBalance: 0,
  turnover: { value: 0, deposit: 0, withdrawal: 0 },
  liabilities: { value: 0, budgetPayment: 0, otherPayment: 0, dividend: 0 },
  costs: { value: 0, transactionCommission: 0, paymentCommission: 0, commission: 0 },
  lpBalance: { value: 0, lpInvest: 0, lpTrade: 0, lpReturn: 0 },
  earning: 0,
  finalBalanceUsd: 0,
  balanceChange: 0,
}

export const $balanceSummary = restore<BalanceSummaryData>(
  getBalanceSummary.doneData.map((a) => {
    const data = a.body
    if (!data) return { ...defaultData }
    return {
      ...defaultData,
      ...data,
      turnover: { ...defaultData.turnover, ...data.turnover },
      liabilities: { ...defaultData.liabilities, ...data.liabilities },
      costs: { ...defaultData.costs, ...data.costs },
      lpBalance: { ...defaultData.lpBalance, ...data.lpBalance },
    }
  }),
  { ...defaultData },
)

export const $passiveBalances = restore<PassiveBalancesData | null>(
  getPassiveBalances.doneData.map((a) => a.body),
  null,
)

const buildDateQuery = () => {
  const now = new Date()
  const dateFrom = `${now.getFullYear()}-${now.getMonth() + 1}-01`
  const dateTo = `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`
  return {
    query: {
      where: JSON.stringify({ dateFrom, dateTo }),
    },
  }
}

sample({
  clock: balanceSummaryMounted,
  fn: buildDateQuery,
  target: getBalanceSummary,
})

sample({
  clock: balanceSummaryMounted,
  fn: buildDateQuery,
  target: getPassiveBalances,
})
